/* eslint-disable react/no-danger */
import React from 'react';

const ModalContentWrapper = ( props ) => {
  return props.children;
};

export default ModalContentWrapper;